/**
 * ファイルダウンロードヘルパー
 * 実DOM操作を抽象化し、ファイルダウンロード機能を提供
 */

/**
 * Blobデータをファイルとしてダウンロード
 * @param blob - ダウンロードするBlobデータ
 * @param filename - ダウンロード時のファイル名
 */
export const downloadBlob = ({
  blob,
  filename,
}: {
  blob: Blob;
  filename: string;
}): void => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

/**
 * 文字列データをテキストファイルとしてダウンロード
 * @param content - ダウンロードするテキストコンテンツ
 * @param filename - ダウンロード時のファイル名
 * @param mimeType - MIMEタイプ（デフォルト: text/plain）
 */
export const downloadText = ({
  content,
  filename,
  mimeType = 'text/plain',
}: {
  content: string;
  filename: string;
  mimeType?: string;
}): void => {
  const blob = new Blob([content], { type: mimeType });
  downloadBlob({ blob, filename });
};

/**
 * CSVデータをダウンロード
 * @param content - CSVコンテンツ
 * @param filename - ダウンロード時のファイル名（.csvを含む）
 */
export const downloadCsv = ({
  content,
  filename,
}: {
  content: string;
  filename: string;
}): void => {
  downloadText({
    content,
    filename,
    mimeType: 'text/csv;charset=utf-8',
  });
};
